module.exports = __webpack_public_path__ + "static/media/teaching_icon_1.731fbb8c.svg";